
// src/apolloGuestClient.js
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getBaseURL } from './baseURL';

/**
 * Apollo Client for the guest/temporary link flow.
 * Uses the same GraphQL endpoint as authenticated flow, but sends the approval token header.
 * Adjust header name if your server expects a different one.
 */
export const GraphQlGuestClient = (approvalToken) => {
  const httpLink = createHttpLink({
    uri: `${getBaseURL()}graphql`, // ✅ same endpoint as authenticated client
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        // Send the token your backend expects for guest access:
        'x-approval-token': approvalToken ?? '',
        // If you ALSO want to send Authorization for some reason, you can add it:
        // authorization: approvalToken ? `Bearer ${approvalToken}` : '',
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });
};
